import React from 'react';
import PropTypes from 'prop-types';

export function EquipmentBlock(props) {
  const notPluggedIn = props.pluggedIn ? '' : 'not'
  return <div  aria-label={`Equipment block. Power supply cables are ${notPluggedIn} plugged in`} tabindex="0" className={props.className}>{props.children}</div>;
}

EquipmentBlock.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
  /**
   * child components inside wrapper
   */
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};
EquipmentBlock.defaultProps = {
  className: '',
};
